import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ResolutionForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    gpName: '',
    meetingType: '',
    meetingLocation: '',
    meetingDate: '',
    subject: '',
    subjectNo: '',
    meetingPeriod: '',
    meetingTime: '',
    resolutionNo: '',
    proposer: '',
    seconder: '',
    resolutionMainPart: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="min-h-screen bg-[#f4f6f9] py-5 px-2 font-sans">
      <style>
        {`
          @media print {
            @page {
              size: A4;
              margin: 10mm;
            }
            body {
              visibility: hidden;
              background: white !important;
            }
            #printable-area {
              visibility: visible;
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              padding: 10mm;
              display: block !important;
              color: black !important;
            }
            .no-print {
              display: none !important;
            }
          }
        `}
      </style>

      {/* Main Form */}
      <div className="w-full bg-white border border-gray-300 shadow-sm rounded-sm overflow-x-auto no-print">
        <div className="bg-[#fff9e6] py-2 px-4 border-b border-gray-300 min-w-[1000px] flex justify-between items-center gap-2">
          <h2 className="text-[#b71c1c] text-left shrink text-[14px] sm:text-[17px] font-bold flex items-center  gap-2">
            <span className="text-blue-600 text-xl leading-none">✹</span> ठराव तयार करा
          </h2>
          <button onClick={() => navigate(-1)} className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold py-1 px-4 rounded text-sm no-print whitespace-nowrap shrink-0">
              मागे जा
            </button>
        </div>

        <div className="p-6 min-w-[1000px]">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-x-10 gap-y-6">
            
            {/* Row 1 */}
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">ग्रामपंचायतीचे नाव</label>
              <select name="gpName" value={formData.gpName} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm bg-white outline-none focus:border-blue-400">
                <option value="">ग्रामपंचायत निवडा</option>
                <option value="धामणी">धामणी</option>
              </select>
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">सभेचा प्रकार निवडा</label>
              <select name="meetingType" value={formData.meetingType} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm bg-white outline-none focus:border-blue-400">
                <option value="">सभेचा प्रकार निवडा</option>
                <option value="मासिक सभा">मासिक सभा</option>
              </select>
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">सभेचे ठिकाण</label>
              <select name="meetingLocation" value={formData.meetingLocation} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm bg-white outline-none focus:border-blue-400">
                <option value="">सभेचे ठिकाण</option>
                <option value="ग्रामपंचायत कार्यालय">ग्रामपंचायत कार्यालय</option>
              </select>
            </div>

            {/* Row 2 */}
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">सभेचा दिनांक</label>
              <input type="date" name="meetingDate" value={formData.meetingDate} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none focus:border-blue-400" />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">सभेचे विषय</label>
              <select name="subject" value={formData.subject} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm bg-white outline-none focus:border-blue-400">
                <option value="">सभेचे विषय</option>
                <option value="विषय १">विषय १</option>
              </select>
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">विषय क्र.</label>
              <input type="text" name="subjectNo" value={formData.subjectNo} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none focus:border-blue-400" />
            </div>

            {/* Row 3 */}
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">सभेचा काळ</label>
              <select name="meetingPeriod" value={formData.meetingPeriod} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm bg-white outline-none focus:border-blue-400">
                <option value="">सभेचा काळ</option>
                <option value="सकाळी">सकाळी</option>
                <option value="दुपारी">दुपारी</option>
              </select>
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">सभेची वेळ</label>
              <select name="meetingTime" value={formData.meetingTime} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm bg-white outline-none focus:border-blue-400">
                <option value="">सभेची वेळ</option>
                <option value="10:00 AM">10:00 AM</option>
              </select>
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">ठराव क्र.</label>
              <input type="text" name="resolutionNo" value={formData.resolutionNo} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none focus:border-blue-400" />
            </div>

            {/* Row 4 */}
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">सुचक</label>
              <input type="text" name="proposer" value={formData.proposer} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none focus:border-blue-400" />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">अनुमोदक</label>
              <input type="text" name="seconder" value={formData.seconder} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none focus:border-blue-400" />
            </div>
            <div></div>

            {/* Main Part Row */}
            <div className="md:col-span-3 flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">ठराव मुख्य भाग</label>
              <textarea 
                name="resolutionMainPart"
                value={formData.resolutionMainPart}
                onChange={handleChange}
                className="border border-[#ccc] rounded-sm px-3 py-2 text-sm outline-none focus:border-blue-400 h-40 resize-none"
              ></textarea>
            </div>

          </div>

          <div className="mt-10 flex gap-4 justify-center">
            <button onClick={handlePrint} className="bg-[#00a65a] text-white px-20 py-1.5 rounded-sm text-sm font-semibold shadow-sm hover:bg-[#008d4c]">Save</button>
            <button className="bg-[#f39c12] text-white px-10 py-1.5 rounded-sm text-sm font-semibold shadow-sm hover:bg-[#e08e0b]">Generate Document</button>
          </div>

          <div className="mt-8 border border-gray-300 rounded-sm min-h-[400px] bg-white"></div>

          <div className="mt-4">
            <button className="bg-[#f4f4f4] border border-[#ddd] text-[#444] px-5 py-1.5 rounded-sm text-xs flex items-center gap-2 hover:bg-[#e8e8e8]">
              <span>🖨️</span> Print
            </button>
          </div>
        </div>
      </div>

      {/* Printable Area */}
      <div id="printable-area" className="hidden print:block font-serif text-black bg-white">
        <div className="text-center mb-10">
          <h1 className="text-[22px] font-bold">ग्रामपंचायत कार्यालय: {formData.gpName}</h1>
          <p className="text-[16px] font-bold mt-1">ठराव प्रत</p>
        </div>

        <p className="text-[16px] leading-relaxed mb-6 text-justify">
          ग्रामपंचायत {formData.gpName} ची **{formData.meetingType}** दिनांक **{formData.meetingDate}** रोजी **{formData.meetingLocation}** येथे आयोजित करण्यात आली होती. सदर सभेमध्ये खालीलप्रमाणे ठराव संमत करण्यात आला:
        </p>

        <div className="border-t border-b border-black py-4 mb-8">
          <p className="font-bold mb-2">विषय क्र. {formData.subjectNo}: {formData.subject}</p>
          <p className="font-bold mb-4">ठराव क्र. {formData.resolutionNo}</p>
          <p className="text-justify leading-loose">{formData.resolutionMainPart}</p>
        </div>

        <div className="flex justify-between mb-20">
          <p>सुचक: {formData.proposer}</p>
          <p>अनुमोदक: {formData.seconder}</p>
        </div>

        <div className="flex justify-between items-end mt-20 pr-10 pl-10 font-bold text-center">
          <div>
            <p>ग्रामसेवक /ग्रामविकास अधिकारी</p>
            <p>ग्रामपंचायत {formData.gpName}</p>
          </div>
          <div>
            <p>सरपंच</p>
            <p>ग्रामपंचायत {formData.gpName}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResolutionForm;
